import options from './application-help.component';

export default {
    selector: 'dtApplicationHelp',
    options
};



// WEBPACK FOOTER //
// ./app/common/help-menu/application-help/index.js